import { render, staticRenderFns } from "./ExamineCmp.vue?vue&type=template&id=67c221de&scoped=true"
import script from "./ExamineCmp.vue?vue&type=script&lang=js"
export * from "./ExamineCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c221de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67c221de')) {
      api.createRecord('67c221de', component.options)
    } else {
      api.reload('67c221de', component.options)
    }
    module.hot.accept("./ExamineCmp.vue?vue&type=template&id=67c221de&scoped=true", function () {
      api.rerender('67c221de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/cmp/Edit/ExamineCmp.vue"
export default component.exports